export default "__VITE_PUBLIC_ASSET__0b319492__"